"use strict";

/**
 * Data model for a facet filter.
 *
 * @id Combination of the Facet id and the key.
 *
 * @key Taken from the value of the search results for the property identified on the facet model.
 * For a course subject area facet the key might be something like ENGL or MATH.
 */
const FilterModel = function(id, key) {
    this.id = id;
    this.key = key;
    //  Number of entities matched. Both projected or actual match counts are stored here.
    this.matchCount = 1;
    // Set this to false initially because the facet allFiltersActive flag will be true.
    this.selected = false;
};

FilterModel.prototype.getId = function() {
    return this.id;
};

FilterModel.prototype.getKey = function() {
    return this.key;
};

FilterModel.prototype.setSelected = function(selected) {
    this.selected = selected;
};

FilterModel.prototype.isSelected = function() {
    return this.selected;
};

FilterModel.prototype.isActionable = function() {
    // If both counts are zero then return false. Otherwise, true.
    return(this.matchCount !== 0);
};

FilterModel.prototype.getMatchCount = function() {
    return(this.matchCount);
};

FilterModel.prototype.incrementMatchCount = function() {
    this.matchCount = this.matchCount + 1;
};


FilterModel.prototype.resetMatchCount = function() {
    this.matchCount = 0;
};

export default FilterModel;